export default __webpack_public_path__ + "static/media/rain.efd4d66c.svg";